import axios from "axios";

const http = axios.create({
  baseURL:
    process.env.REACT_APP_BACKEND_URL || "https://backend.enterinsights.com",
  // baseURL: "http://localhost:5001",
});

export default http;
